// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5a007c84] .v-slider__thumb {\n  cursor: pointer;\n  border: 1px solid #fff !important;\n}\n[data-v-5a007c84] .v-slider__thumb::before {\n  opacity: 0;\n}\n[data-v-5a007c84] .v-slider__track-fill,[data-v-5a007c84] .v-slider__track-background {\n  border-radius: 9px;\n}\n[data-v-5a007c84] .v-slider__track-container {\n  height: 5px;\n}", ""]);
// Exports
module.exports = exports;
